// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget.monitors {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex: 1;
}

.monitors {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.monitors .monitors-row {
  display: flex;
  flex-direction: row;
  flex: 1;
  font-size: 0.75em;
  font-family: monospace;
  text-transform: uppercase;
  min-height: 0;
}

.monitors .monitor {
  border: 1px solid gray;
  flex: 1;
  position: relative;
}

.monitors .monitor .track-name {
  position: absolute;
  left: 2px;
  top: 0;
  font-size: 1em;
  font-family: monospace;
  color: dimgrey;
}

.monitors .monitor-empty {
  background:
    repeating-linear-gradient(
      45deg,
      #222,
      #222 10px,
      #111 10px,
      #111 20px
    );
}

.monitors .blank {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/monitors/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;;;;;;;KAOG;AACL;;AAEA;EACE,OAAO;AACT","sourcesContent":[".widget.monitors {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  flex: 1;\n}\n\n.monitors {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.monitors .monitors-row {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  font-size: 0.75em;\n  font-family: monospace;\n  text-transform: uppercase;\n  min-height: 0;\n}\n\n.monitors .monitor {\n  border: 1px solid gray;\n  flex: 1;\n  position: relative;\n}\n\n.monitors .monitor .track-name {\n  position: absolute;\n  left: 2px;\n  top: 0;\n  font-size: 1em;\n  font-family: monospace;\n  color: dimgrey;\n}\n\n.monitors .monitor-empty {\n  background:\n    repeating-linear-gradient(\n      45deg,\n      #222,\n      #222 10px,\n      #111 10px,\n      #111 20px\n    );\n}\n\n.monitors .blank {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
